import { render, staticRenderFns } from "./AddUpdates.vue?vue&type=template&id=0871e46e&scoped=true&"
import script from "./AddUpdates.vue?vue&type=script&lang=js&"
export * from "./AddUpdates.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdates.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddUpdates.vue?vue&type=style&index=1&id=0871e46e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871e46e",
  null
  
)

export default component.exports